// Turns the /api/progress/summary response into the "skills completed" view
// the learning path is built around.

// Correct answers needed before a skill counts as completed.
export const SKILL_TARGET = 30;

const EMPTY_STATS = { total: 0, graded: 0, correct: 0 };

// Per-standard stats, keyed by standard code, for one state and grade.
export function buildStandardStats(summary, { state, grade } = {}) {
  const map = new Map();
  (summary || []).forEach((entry) => {
    if (state && entry.state !== state) return;
    if (grade && entry.gradeLevel !== grade) return;
    (entry.majorTopics || []).forEach((majorTopic) => {
      (majorTopic.standards || []).forEach((standard) => {
        map.set(standard.code, standard);
      });
    });
  });
  return map;
}

export function skillProgress(goalSection, standardStats) {
  const stats = standardStats.get(goalSection.code) || EMPTY_STATS;
  const total = goalSection.questionCount || stats.total || 0;
  const target = Math.min(SKILL_TARGET, total);
  const correct = stats.correct || 0;
  return {
    total,
    target,
    correct,
    attempted: stats.graded || 0,
    completed: target > 0 && correct >= target,
    started: (stats.graded || 0) > 0,
    percentage: target > 0 ? Math.min(100, Math.round((correct / target) * 100)) : 0,
  };
}

export function summariseSkills(skills, standardStats) {
  const stats = skills.map((skill) => skillProgress(skill, standardStats));
  const total = stats.length;
  const completed = stats.filter((stat) => stat.completed).length;
  return {
    total,
    completed,
    started: stats.filter((stat) => stat.started).length,
    percentage: total > 0 ? Math.round((completed / total) * 100) : 0,
  };
}

export function skillStatusLabel(stats) {
  if (stats.completed) return 'Completed';
  if (stats.started) return 'In progress';
  return 'Not started';
}

export function skillStatusTone(stats) {
  if (stats.completed) return 'done';
  if (stats.started) return 'active';
  return 'todo';
}
